var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:'icons d-flex flex-colum '+_vm.breakClass},[_c('li',{class:_vm.iconClass,domProps:{"innerHTML":_vm._s(_vm.value)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }